import { createFile } from '#apps/client-web/features/file-storage/helpers';
import { type FileContent } from '#apps/client-web/features/file-storage/services/file-storage';
import { parseIntOrUndefined } from '#apps/client-web/utils/helpers';

import { IdGeneratorService } from '#packages/data-collection/services/id-generator';
import { type Attachment } from '#packages/data-collection/models/common/attachment';
import { type AuditLightingTypeFormEntry } from '#packages/data-collection/models/audit-lighting-type-form';

import { type EditAuditFormLightingTypeEntryData } from './types';

export const fromFormData = (
  formData: EditAuditFormLightingTypeEntryData,
  attachments?: Attachment[],
): AuditLightingTypeFormEntry => ({
  id: formData.id,
  quantity: parseIntOrUndefined(formData.quantity),
  lightSource: formData.lightSource,
  lampType: formData.lampType,
  lampBase: formData.lampBase,
  lampWattage: parseIntOrUndefined(formData.lampWattage),
  fixtureType: formData.fixtureType,
  fixtureSize: formData.fixtureSize,
  fixtureMount: formData.fixtureMount,
  attributes: formData.attributes,
  colorTemperature: formData.colorTemperature,
  ballastFactor: parseIntOrUndefined(formData.ballastFactor),
  fixtureWattage: parseIntOrUndefined(formData.fixtureWattage),
  luminaireName: formData.luminaireName,
  comments: formData.comments,
  attachments,
});

const idGenerator = new IdGeneratorService();

export const toFormData = (
  entryData: AuditLightingTypeFormEntry | undefined,
  files?: (FileContent | undefined)[],
): Partial<EditAuditFormLightingTypeEntryData> => ({
  id: entryData?.id ?? idGenerator.generate(),
  quantity: entryData?.quantity?.toString(),
  lightSource: entryData?.lightSource,
  lampType: entryData?.lampType,
  lampBase: entryData?.lampBase,
  lampWattage: entryData?.lampWattage?.toString(),
  fixtureType: entryData?.fixtureType,
  fixtureSize: entryData?.fixtureSize,
  fixtureMount: entryData?.fixtureMount,
  attributes: entryData?.attributes,
  colorTemperature: entryData?.colorTemperature,
  ballastFactor: entryData?.ballastFactor?.toString(),
  fixtureWattage: entryData?.fixtureWattage?.toString(),
  luminaireName: entryData?.luminaireName,
  comments: entryData?.comments,
  attachments: entryData?.attachments?.map((attachment, index) => ({
    ...attachment,
    file: createFile({
      content: files![index]!,
      name: attachment.name,
      mimeType: attachment.mimeType,
    }),
  })),
});
